import {
  GET_CONTROL_SHEET_REQUEST,
  GET_CONTROL_SHEET_SUCCESS,
  GET_CONTROL_SHEET_ERROR,
  GET_CONTROL_SHEET_ADVANCE_REQUEST,
  GET_CONTROL_SHEET_ADVANCE_SUCCESS,
  GET_CONTROL_SHEET_ADVANCE_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getControlSheet = (token) => (dispatch) => {
  dispatch({ type: GET_CONTROL_SHEET_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/controlSheet`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_CONTROL_SHEET_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CONTROL_SHEET_ERROR,
        payload: [],
      });
    });
};


export const getControlSheetAdvance = (token) => (dispatch) => {
  dispatch({ type: GET_CONTROL_SHEET_ADVANCE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ControlSheetAdvance`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_CONTROL_SHEET_ADVANCE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CONTROL_SHEET_ADVANCE_ERROR,
        payload: [],
      });
    });
};
